import "core-js/modules/web.dom-collections.iterator.js";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont-front icon-back"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "c-navigation-bar hairlines",
    style: _normalizeStyle([$options.rootStyles, $options.statusBarRootStyles])
  }, [_createElementVNode("div", {
    class: "c-navigation-bar-wrap one_card_bg",
    style: _normalizeStyle([$options.wrapStyles, $options.statusBarWrapStyles])
  }, [_createElementVNode("div", {
    class: "c-navigation-bar-back",
    style: _normalizeStyle($options.backStyles),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleBack && $options.handleBack(...args))
  }, [_renderSlot(_ctx.$slots, "left", {}, () => [_hoisted_1])], 4), _createElementVNode("div", {
    class: "c-navigation-bar-title one_text_color",
    style: _normalizeStyle($options.titleStyles)
  }, [_renderSlot(_ctx.$slots, "title", {}, () => [_createTextVNode(_toDisplayString($props.title), 1)])], 4), _createElementVNode("div", {
    class: "c-navigation-bar-right active_color",
    style: _normalizeStyle($options.rightStyles)
  }, [_renderSlot(_ctx.$slots, "right")], 4)], 4)], 4);
}